export default "__VITE_ASSET__DPkTpCdP__"